import React from "react";
import { Link } from "react-router-dom";
import { Calculator, FileText, ShieldCheck, Landmark, Scale, TrendingUp, RefreshCw, ShieldAlert } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { pageBanner } from "../mock";
import { translations, serviceImages, serviceIconNames } from "../translations";
import { useLanguage } from "../context/LanguageContext";

const ICONS = { Calculator, FileText, ShieldCheck, Landmark, Scale, TrendingUp, RefreshCw, ShieldAlert };

const Services = () => {
  const { lang } = useLanguage();
  const t = translations[lang];

  return (
    <div>
      <PageHero title={t.servicesPage.pageTitle} image={pageBanner} />

      <section className="py-20 bg-white">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
          <Reveal className="text-center">
            <h2 className="font-serif text-3xl md:text-4xl font-bold brand-navy dash-center">{t.servicesPage.indexHeading}</h2>
          </Reveal>

          <div className="grid md:grid-cols-2 gap-7 mt-14">
            {t.services.map((s, i) => {
              const Icon = ICONS[serviceIconNames[s.id]] || ShieldCheck;
              return (
                <Reveal key={s.id} delay={(i % 2) * 100}>
                  <div className="group flex gap-5 bg-[#f6f8f6] rounded-sm p-7 h-full border border-transparent hover:border-gold hover:shadow-lg transition-all duration-300">
                    <div className="shrink-0">
                      <div className="w-14 h-14 rounded-sm overflow-hidden relative">
                        <img src={serviceImages[s.id]} alt={s.title} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-steel/55 flex items-center justify-center text-white">
                          <Icon size={22} />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="font-serif text-sky-accent font-bold text-sm">0{i + 1}</span>
                        <h3 className="font-serif text-xl font-bold brand-navy leading-snug group-hover:text-sky-accent transition-colors">{s.title}</h3>
                      </div>
                      <p className="text-slate-600 text-sm mt-3 leading-relaxed">{s.short}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <div className="text-center mt-14">
            <Link to="/contact-us" className="pill-btn">{t.ui.getInTouch}</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
